// constants from https://github.com/pnorental/conti/blob/master/src/conti/consts.go 

const removalReasons = {
    "NORMAL_WEAR": "Normal wear",
    "WHEEL_CHANGE": "Wheel change",
    "PUNCTURE": "Puncture",
    "IMPACT_DAMAGE": "Impact damage",
    "ABNORMAL_WEAR_ONE_SIDE": "Abnormal wear one side",
    "CUTS": "Cuts",
    "SIDEWALL_SCUFFING": "Sidewall Scuffing",
    "TREAD_DAMAGE": "Tread damage",
    "RUN_FLAT": "Run flat",
    "THEFT": "Theft",
}

export const RemovalReasons = { ...removalReasons };

export const RemovalReason = function (reason) {
    return removalReasons[reason] ? removalReasons[reason] : null
}
